import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Box, Typography, Paper } from "@mui/material";

import Provider from "../../../../../../Provider";
import { getUnitPropertie } from "../../functions";

function TaskFieldMultipleUploadRequired(props) {
  const { id, fieldProperties } = props;

  const label = getUnitPropertie(fieldProperties, "label");
  const apiUrl = getUnitPropertie(fieldProperties, "apiUrl");

  return (
    <Provider>
      <Box sx={{ width: "100%", overflow: "hidden", maxWidth: "100%" }}>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            mb: 1,
            color: "#2c3e50",
            fontSize: "14px",
          }}
        >
          {label}
        </Typography>
        <Paper
          sx={{
            border: "2px dashed #bdc3c7",
            p: 3,
            textAlign: "center",
            mb: 2,
            cursor: "pointer",
            transition: "all 0.3s ease",
            minHeight: "120px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <UploadFileIcon sx={{ fontSize: 40, color: "#175EA2", mb: 1 }} />
          <Typography variant="body1" sx={{ mb: 1 }}>
            <Box
              component="span"
              sx={{
                color: "#175EA2",
                textDecoration: "underline",
                fontWeight: 600,
              }}
            >
              Clique para selecionar
            </Box>{" "}
            <Box component="span" sx={{ fontWeight: 600, color: "#2c3e50" }}>
              ou arraste e solte
            </Box>
          </Typography>
          {apiUrl && (
            <Typography
              variant="caption"
              sx={{ color: "#7f8c8d", fontSize: "11px" }}
            >
              API: {apiUrl}
            </Typography>
          )}
        </Paper>
      </Box>
    </Provider>
  );
}

export default TaskFieldMultipleUploadRequired;
